import type { LocationQueryValue } from 'vue-router';

function stringToEnum<T>(str: string, options: readonly T[]): T | undefined {
  for (const option of options) {
    if (str === option) return option;
  }
  return;
}

function queryToEnum<T>(queryValue: LocationQueryValue | LocationQueryValue[], options: readonly T[]): T | undefined {
  if (typeof queryValue !== 'string') {
    return;
  }
  return stringToEnum(queryValue, options);
}

export { stringToEnum, queryToEnum };
